import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthProvider';

export default function Topbar() {
  const { member, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <header className="pf-topbar">
      <Link className="pf-brand" to="/">
        <i className="ri-heart-3-line" aria-hidden="true" />
        <span>모바일 청첩장</span>
      </Link>

      <div className="pf-topbar-actions">
        {member ? (
          <>
            {member.role === 'admin' ? (
              <Link className="pf-btn sm ghost" to="/admin">
                <i className="ri-shield-user-line" aria-hidden="true" />
                회원 관리
              </Link>
            ) : member.status === 'approved' ? (
              <Link className="pf-btn sm ghost" to="/my">
                <i className="ri-gallery-line" aria-hidden="true" />
                내 청첩장
              </Link>
            ) : null}
            <span className="pf-user-chip">
              <i className="ri-user-3-line" aria-hidden="true" />
              <span className="chip-text">{member.name || member.email}</span>
            </span>
            <button type="button" className="pf-btn sm" onClick={() => void handleSignOut()}>
              <i className="ri-logout-box-r-line" aria-hidden="true" />
              로그아웃
            </button>
          </>
        ) : (
          <>
            <Link className="pf-btn sm ghost" to="/login">
              로그인
            </Link>
            <Link className="pf-btn sm primary" to="/signup">
              청첩장 만들기
            </Link>
          </>
        )}
      </div>
    </header>
  );
}